/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon_vendor_azure': {
    width: 18,
    height: 18,
    viewBox: '0 0 18 18',
    data: '<g _fill="none" fill-rule="evenodd"><path pid="0" d="M-3-3h24v24H-3z"/><path pid="1" d="M0 .018C.106-.006.211 0 .322.004c2.557 0 5.12-.005 7.678 0v7.991c-2.663.01-5.327 0-7.99.005C-.005 5.341.014 2.677 0 .018" _fill="#F25022"/><path pid="2" d="M10 .015c.091-.02.187-.014.278-.014 2.577.004 5.15 0 7.722.004 0 2.662-.005 5.324 0 7.98-2.659.025-5.322-.004-7.98.015-.034-.13-.01-.269-.02-.403 0-2.527.01-5.055 0-7.582" _fill="#7FBA00"/><path pid="3" d="M.002 14.338c.005-1.444-.01-2.894.005-4.338 2.664.005 5.329 0 7.993.005v7.99c-2.664.005-5.329 0-7.989.005-.019-1.219-.004-2.438-.01-3.662" _fill="#00A4EF"/><path pid="4" d="M10 10.016c.106-.024.216-.014.331-.014h7.53c.033.005.105.005.139.01-.005 2.662 0 5.32 0 7.983-1.92.005-3.834 0-5.754.005-.749-.01-1.497.01-2.246-.01.005-2.658.005-5.316 0-7.974" _fill="#FFB900"/></g>'
  }
})



// WEBPACK FOOTER //
// ./src/components/icons/icon_vendor_azure.js